const KawaiiAlbumsStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static"> 

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/34zYfGetvk75MwtyN4oThG?si=1D7d9jUpQxu30GFv9zodrA" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0229b2f2cd2fbaf161ab86bbeb" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Kawaii Ry & Meauxminy - Visions</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/5gkCKPsIkKRUdbaGCem5p6?si=ZmWSVJB-Ttuyq6krZgu_VQ" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02165adc96751fcdfd89a71fb8" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>BLEEZY SEAZY V</strong><br/>(prod. chris6lair)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/0IqSbY1aTlQzXwSsIyJoeo?si=7XAmnJ1iRUOcrCXXRC-H-g" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-mepLuhhx8vY3fKo0-ZFrxug-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Space Quest</strong><br/>(prod. Baredex)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/2oq7EGlpThVFL8buqJcs6v?si=7ocmUVCmQ3u9CyYd7AXM9g" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-zNjezkg8qbFqiFKY-wPllXQ-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>BLEEZY SEAZY IV</strong><br/>(prod. chris6lair)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/5i43dPAoghBM5HqhJyyFga?si=KuZSbEH2QbeXlGJreOoFZA" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-Gu6OVaO4vhT4lHEK-GylG5A-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>The Drop Off</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/3tuJhiJJJl47JJhU8kdCQH?si=1EqxtmemTeuzp0yCCr4H2w" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-mNjoZfs4ncaHSVx0-83Gnmw-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>I Cry, I Bleed</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/3Cg1oeHtDkO6iRgVcv9sok?si=CNRU9M62QdC3vjpJeq5T7g" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-nZHypsKCH9WPzk4z-44ObSQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>BLEEZY SEAZY III </strong><br/>(prod. chris6lair)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/6phk15MEf67TkrlpJ6BW0u?si=mg64TCx3SQGJSW_075dW8Q" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Alone Together </strong><br/>(prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/6wLFadNSS3Uv1wgYaM1M0b?si=Tm93dx20TOGFoLrEHKVD9Q" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-il9NATXFnn8xquQe-onkrAQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Slime Shawty 2</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/7mygx4N05Il50UcBbLPI4V?si=8JXBdqaBSB6Jkz3JR8J0cw" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b273f2f2bf001f382b16315b7ac3" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Lugosi - Bimmy Boys</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/6VuabdaL17mTNuxhVDeRUD?si=bIKyvilAR4SphXqVWyvTMA" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b273b12f570d61f237e614460ea7" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Meaux Money Less Talk</strong><br/>(prod. Meauxminy)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/7BT2hW7eoWgOrWRALq14QR?si=OPmNtn9BTmuVsVcwJZumUA" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d00001e02eb6ed43d5b7a864793e53697" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Club Kawaii</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/7zLxfhulK3PoEwXwbO7J7t" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b27396c6aa05e224dd591203ac34" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Glo Baby</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://soundcloud.com/kawaiiry/sets/title-tba" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-M39kJuvPJSKxzJqq-aiIS1A-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Depression & Weapons</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://soundcloud.com/kawaiiry/sets/forbiddenlove" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-YWJaywTZuUy0wlhW-x3lXJA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Forbidden Love</strong><br/>
                (prod. Semaj)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://soundcloud.com/kawaiiry/sets/beautiful-heartbreak" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-M0Rzq7jdHWKlMJHT-ormDZw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Beautiful Heartbreak</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://soundcloud.com/kawaiiry/sets/toad-arc" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-Zy2efuUGXKFOmrQy-zGctQw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Toad Arc</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://soundcloud.com/kawaiiry/sets/kawaii-ry-voidproducedit-title" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-J0ieqbBznpok9SIh-LUrTEA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Spin the Bottle</strong><br/>
                (prod. void)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://soundcloud.com/kawaiiry/sets/slime-shawty-ep" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-F34d7Juzp4RK1yh6-0zrTzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Slime Shawty</strong><br/>
              </p>
            </a>
          </div>                                                                                                                                 
        
        </div>
      </>
    );
  };
  export default KawaiiAlbumsStatic;